// External links used in the app shell.
export const TMS_BETA_URL =
    "https://translyx.app/contact/?subject=tms&utm_source=translyx-cat&utm_medium=app-sidebar&utm_campaign=tms-beta";
